import { deleteCookie, useCookies } from 'common-module/src/util/useCookies';
import qs from 'querystring';
import dayjs from 'dayjs';

const TEST_DOMAIN = /^(app-)?((dev|sit)[1-9]?)(-[a-z]*)?(\.leiga\.net|\.leigaqa\.com|\.ai4prd\.com)$/;
const domainMatch = location.hostname.match(TEST_DOMAIN);
const domainTokenKey = domainMatch ? `-${domainMatch[2]}` : '';

export const TokenKey = `pms-app-token${domainTokenKey}`;
export const SAML_LOGOUT_MARKER_KEY = 'ligaai.saml-logout';
const SAML_LOGOUT_MARKER_TTL = 10 * 1000;
const NameKey = 'pms-app-name';

const ipRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
function isIPv4(hostname: string) {
  return ipRegex.test(hostname);
}

export const getTopLevelDomain = (domain: string) => {
  if (domain === 'localhost' || isIPv4(domain)) {
    return domain;
  }
  // 如果输入已经是顶级域名
  if (domain.startsWith('.')) {
    return domain;
  }

  // 分割域名为各个部分
  const parts = domain.split('.');

  // 取最后两个部分作为顶级域名的一部分，假设顶级域名不会有二级后缀如.co.uk
  // （如果需要处理这种情况，那么就需要一个特殊的后缀列表来确定何时需要额外的部分）
  const topLevelDomainParts = parts.slice(-2);

  // 将顶级域名的部分连接起来，添加点作为前缀
  return `.${topLevelDomainParts.join('.')}`;
};
const cookies = useCookies([TokenKey]);
const COOKIE_OPTIONS: Parameters<typeof cookies.set>[2] = {
  path: '/',
  secure: true,
  sameSite: 'none',
  expires: dayjs().add(14, 'day').toDate(),
  maxAge: 14 * 24 * 60 * 60,
  domain: getTopLevelDomain(location.hostname)
};

export const addTokenChangeListener = (callback: Parameters<typeof cookies.addChangeListener>[0]) => {
  cookies.addChangeListener(callback);
};

export const markSamlLogoutInProgress = () => {
  window.sessionStorage.setItem(SAML_LOGOUT_MARKER_KEY, String(Date.now()));
};

export const isSamlLogoutInProgress = () => {
  const timestamp = Number(window.sessionStorage.getItem(SAML_LOGOUT_MARKER_KEY));
  if (!timestamp) {
    return false;
  }
  if (Date.now() - timestamp <= SAML_LOGOUT_MARKER_TTL) {
    return true;
  }
  window.sessionStorage.removeItem(SAML_LOGOUT_MARKER_KEY);
  return false;
};

export function getToken() {
  const shareToken = getShareToken();
  if (shareToken) {
    return shareToken;
  }
  let token = cookies.get<string>(TokenKey) || '';
  token = `${token}`.toLowerCase() === 'null' ? '' : token;
  return token;
}

export function setToken(token = '') {
  cookies.set(TokenKey, token, COOKIE_OPTIONS);
}

export function removeToken() {
  setToken('');
  cookies.remove(TokenKey, COOKIE_OPTIONS);
}

export function getUserName() {
  return localStorage.getItem(NameKey);
}

export function setUserName(name = '') {
  return localStorage.setItem(NameKey, name);
}

export function removeUserName() {
  return localStorage.removeItem(NameKey);
}

export const getShareToken = () => {
  const query = qs.parse(window.location.search.slice(1));
  const shareCode = query.shareCode;
  if (!shareCode) {
    return null;
  }
  return sessionStorage.getItem(`token-share-${shareCode}`);
};

// 删除旧的全域token
if (cookies.get<string>(TokenKey) === '') {
  deleteCookie(TokenKey);
}
